import requests from '../../request'

const baseUrl = '/purchase/config';
const region = 'cloud-api';

/**
 * 根据ID查询
 * @param id
 */
export const get = (params) => {
    return requests({
        url: baseUrl,
        method: 'get',
        params
    }
    );
}

/**
 * 修改
 * @param data
 */
export const update = (params) => {
    return requests({
        url: baseUrl,
        method: 'put',
        params,
    },
        {
            contentType: 'application/x-www-form-urlencoded;charset=UTF-8',
        });
}